import { patch } from '../components/OrgManagement/common'
import { post } from '@/helpers/api'
import { updateOrganization } from '@/store'

export const updateOrg = async (payload, cancelToken) => {
	try {
		const organization = await patch('/organization', payload, cancelToken)
		organization.profilepic = !!organization.profilepicurl
		updateOrganization(organization)
		return organization
	} catch (e) {
		console.error(e)
		throw e
	}
}

// organization report related calls
export const createReport = async (payload, cancelToken) => {
	try {
		const { data } = await post('/api/v1/report.create', payload, cancelToken)

		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const fetchReportList = async (payload, cancelToken) => {
	try {
		const { data } = await post('/api/v1/report.list', payload, cancelToken)

		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const fetchReportInfo = async (payload, cancelToken) => {
	try {
		const { data } = await post('/api/v1/report.info', payload, cancelToken)

		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}

export const deleteReport = async (payload, cancelToken) => {
	try {
		const { data } = await post('/api/v1/report.delete', payload, cancelToken)

		return data
	} catch (e) {
		console.error(e)
		throw e
	}
}
